<script setup lang="ts" generic="T extends string">
import { ref, watch, onMounted } from "vue";
import { injectStyle } from "@zyzgroup/core-web";
import Icon from "./Icon.vue";
import Button from "./Button.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Icon, Button }
});

const props = withDefaults(
  defineProps<{
    options: Array<T>;
    initIndex?: number;
    fontSize?: string;
  }>(),
  { initIndex: 0, fontSize: "14px" }
);

const emits = defineEmits<{
  (event: "change", index: number, value: T): void;
}>();

onMounted(() => {
  injectStyle(`
    :root {
      --select-option-bg-color: #ffffff;
      --select-option-bg-color-hover: #f5f5f5;
    }
  `);
});

const open = ref(false);

const selectedIndex = ref(props.initIndex);

watch(selectedIndex, function () {
  emits("change", selectedIndex.value, props.options[selectedIndex.value]);
});

function click() {
  open.value = !open.value;
}
function change(index: number) {
  selectedIndex.value = index;
  open.value = false;
}
</script>

<template>
  <div
    class="select"
    :style="['font-size:' + fontSize]"
  >
    <div @click="click">
      <slot
        name="button"
        :selectedIndex="selectedIndex"
      >
        <Button
          icon="carbon:chevron-sort"
          iconPosition="right"
          :label="options[selectedIndex]"
          style="width: 100%"
        ></Button>
      </slot>
    </div>

    <div
      v-show="open"
      class="options"
      :style="{ border: '1px solid #cccccc' }"
    >
      <div
        @click="change(index)"
        class="option"
        v-for="(option, index) in options"
        :key="index"
        :value="index"
        :style="{
          borderTop: (index == 0 ? '0' : '1px') + ' solid #cccccc'
        }"
      >
        <div class="option-inner">
          <slot
            :item="option"
            :index="index"
          >
            <span>
              {{ option }}
            </span>
            <Icon
              v-if="index == selectedIndex"
              icon="mingcute:check-fill"
              class="icon"
            ></Icon>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.select {
  display: inline-block;
  position: relative;
}
.options {
  position: relative;
  width: 100%;
  text-align: center;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #ffffff;
}
.option {
  cursor: pointer;
}
.option-inner {
  padding: 0.5em 1em 0.5em 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: var(--select-option-bg-color);
}
.option-inner:hover {
  background-color: var(--select-option-bg-color-hover);
}
.icon {
  position: absolute;
  right: 0.5em;
  top: 50%;
  transform: translate(0, -50%);
}
</style>
